var LAZY_LOAD = {
  NATIVE: 'NATIVE',
  CSS: 'CSS'
};
export default LAZY_LOAD;